import * as yup from "yup";
import { Validation } from "../../utils/Validation.utils";
export const PriorityReferralInitialValues = {
    referredEmails: [],
    priorityEntryId: ""
};
export const PriorityReferralSchema = yup.object().shape({
    referredEmails: yup
        .array()
        .of(yup.string().email(Validation.Email))
        .required("Please enter a valid email address to send the referral to."),
    priorityEntryId: yup
        .string()
        .required("Please enter a valid priority entry id.")
});
